export const asyncProjectFields = [
  {
    id: "title",
    placeholder: "titre"
  },
  {
    id: "shortDescription",
    placeholder: "Description courte"
  },
  {
    id: "urlGithub",
    placeholder: "Url Github",
    type: "url"
  },
  {
    id: "urlTest",
    placeholder: "Url preview",
    type: "url"
  },
  {
    id: "nbImages",
    type: "number",
    min: 0,
    max: 20,
    defaultValue: 0
  },
  {
    id: "imgPrefix",
    placeholder: "Préfixe images"
  }
];
